"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentSection = exports.ContentRow = exports.ContentCol = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "className", "containerElement", "float", "noGutters", "padded", "verticalAlign"],
  _excluded2 = ["children", "className", "containerElement", "expand", "float", "gutters", "shrink"],
  _excluded3 = ["children", "className", "containerElement"];
/**
 * SPDX-FileCopyrightText: © 2020 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var ContentRow = exports.ContentRow = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classNames;
  var children = _ref.children,
    className = _ref.className,
    _ref$containerElement = _ref.containerElement,
    ContainerElement = _ref$containerElement === void 0 ? 'div' : _ref$containerElement,
    float = _ref.float,
    noGutters = _ref.noGutters,
    padded = _ref.padded,
    verticalAlign = _ref.verticalAlign,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'autofit-row', (_classNames = {
      'autofit-float': float === true
    }, _defineProperty(_classNames, "autofit-float-".concat(float), typeof float === 'string'), _defineProperty(_classNames, 'autofit-padded', padded), _defineProperty(_classNames, 'autofit-padded-no-gutters', noGutters === true), _defineProperty(_classNames, "autofit-padded-no-gutters-".concat(noGutters), typeof noGutters === 'string'), _defineProperty(_classNames, "autofit-row-".concat(verticalAlign), verticalAlign), _classNames)),
    ref: ref
  }), children);
});
ContentRow.displayName = 'ClayContentRow';
var ContentCol = exports.ContentCol = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    className = _ref2.className,
    _ref2$containerElemen = _ref2.containerElement,
    ContainerElement = _ref2$containerElemen === void 0 ? 'div' : _ref2$containerElemen,
    expand = _ref2.expand,
    float = _ref2.float,
    gutters = _ref2.gutters,
    shrink = _ref2.shrink,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'autofit-col', _defineProperty({
      'autofit-col-expand': expand,
      'autofit-col-gutters': gutters,
      'autofit-col-shrink': shrink
    }, "autofit-col-".concat(float), float)),
    ref: ref
  }), children);
});
ContentCol.displayName = 'ClayContentCol';
var ContentSection = exports.ContentSection = /*#__PURE__*/_react.default.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    className = _ref3.className,
    _ref3$containerElemen = _ref3.containerElement,
    ContainerElement = _ref3$containerElemen === void 0 ? 'div' : _ref3$containerElemen,
    otherProps = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'autofit-section'),
    ref: ref
  }), children);
});
ContentSection.displayName = 'ClayContentSection';